// ==============================
// KycProgressBar.js
// Barra di progresso visuale per gli 8 step KYC
// Usa il theme per colori consistenti
// ==============================

import React from 'react';
import { useTranslation } from 'react-i18next';
import { COLORS, SEMANTIC, UI } from '../styles/theme';

const KycProgressBar = ({ currentStep, totalSteps = 10 }) => {
  const progress = ((currentStep - 1) / totalSteps) * 100;
  const { t } = useTranslation();

  return (
    <div style={{ marginBottom: UI.spacing.xl }}>
      {/* Indicatore testuale */}
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: UI.spacing.sm,
        }}
      >
        <span
          style={{
            color: SEMANTIC.textSecondary,
            fontSize: UI.fontSize.sm,
          }}
        >
          {t('kyc.progress', { current: currentStep, total: totalSteps })}
        </span>
        <span
          style={{
            color: SEMANTIC.textSecondary,
            fontSize: UI.fontSize.sm,
          }}
        >
          {Math.round((currentStep / totalSteps) * 100)}%
        </span>
      </div>

      {/* Barra di progresso */}
      <div
        style={{
          width: '100%',
          height: '6px',
          background: COLORS.GRAY_DARK.hex,
          borderRadius: UI.borderRadius.pill,
          overflow: 'hidden',
        }}
      >
        <div
          style={{
            width: `${progress}%`,
            height: '100%',
            background: SEMANTIC.ctaPrimary,
            borderRadius: UI.borderRadius.pill,
            transition: UI.transition.normal,
          }}
        />
      </div>

      {/* Pallini degli step */}
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          marginTop: UI.spacing.md,
        }}
      >
        {Array.from({ length: totalSteps }, (_, i) => {
          const stepNum = i + 1;
          const isCompleted = stepNum < currentStep;
          const isCurrent = stepNum === currentStep;

          return (
            <div
              key={stepNum}
              style={{
                width: '24px',
                height: '24px',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: UI.fontSize.xs,
                fontWeight: UI.fontWeight.bold,
                transition: UI.transition.fast,
                background: isCompleted
                  ? SEMANTIC.ctaPrimary
                  : isCurrent
                    ? 'transparent'
                    : COLORS.GRAY_DARK.hex,
                color: isCompleted
                  ? SEMANTIC.ctaPrimaryText
                  : isCurrent
                    ? SEMANTIC.ctaPrimary
                    : SEMANTIC.textDisabled,
                border: isCurrent
                  ? `2px solid ${SEMANTIC.ctaPrimary}`
                  : '2px solid transparent',
              }}
            >
              {isCompleted ? (
                <i className="bi bi-check" style={{ fontSize: '14px' }} />
              ) : (
                stepNum
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default KycProgressBar;
